import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_text = _resolveComponent("n-text")!
  const _component_n_space = _resolveComponent("n-space")!

  return (_openBlock(), _createBlock(_component_n_space, { vertical: "" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infoElements, (el, elIndex) => {
        return (_openBlock(), _createBlock(_component_n_space, { key: elIndex }, {
          default: _withCtx(() => [
            _createVNode(_component_n_text, { type: "info" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(el.label) + ":", 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_n_text, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(el.content), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}